import { SENIOR, JUNIOR } from './Auth';

export const MENU = [
  {
    title: '统计概况',
    name: 'status',
    child: [
      { name: 'statistics', label: '统计', allowed: [SENIOR, JUNIOR] },
      { name: 'report', label: '报表', allowed: [SENIOR, JUNIOR] },
      { name: 'trafficReport', label: '流量报表', allowed: [SENIOR, JUNIOR] }
    ]
  },
  {
    title: '设备管理',
    name: 'device',
    child: [
      { name: 'info', label: '设备详情', allowed: [SENIOR, JUNIOR] },
      { name: 'group', label: '设备分组', allowed: [SENIOR, JUNIOR] },
      { name: 'config', label: '设备配置', allowed: [SENIOR] },
      { name: 'OTA', label: 'OTA升级', allowed: [SENIOR] }
      // { name: 'factory', label: '出厂信息' }
    ]
  },
  {
    title: 'App管理',
    name: 'app',
    child: [
      { name: 'file', label: '文件管理', allowed: [SENIOR, JUNIOR] },
      { name: 'strategy', label: '推送策略', allowed: [SENIOR, JUNIOR] },
      { name: 'firmware', label: '固件管理', allowed: [SENIOR] }
    ]
  }
];

export const filterByAuth = (auth = null) => {
  return MENU.map(i => ({
    ...i,
    child: i.child.filter(j => j.allowed.some(z => z === auth))
  })).filter(i => i.child.length > 0);
};



// WEBPACK FOOTER //
// ./src/const/Menu.js